import { Extension } from '@tiptap/core'
import { IndentActionButton } from '@/tiptap/extensions/components/ActionButton'

export default Extension.create({
  name: 'indent',

  addOptions() {
    return {
      divider: false,
      spacer: false,
      button: ({ editor, t }) => ({
        component: IndentActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})
